import { humanizer } from 'humanize-duration'

export function humanize(milliseconds: number): string {
  const format = humanizer({
    language: 'pt-BR',
    languages: {
      'pt-BR': {
        y: () => 'ano',
        mo: () => 'mês',
        w: () => 'sem',
        d: () => 'd',
        h: () => 'h',
        m: () => 'm',
        s: () => 's',
        ms: () => 'ms',
      },
    },
    spacer: '',
    conjunction: ' ',
    serialComma: false,
    maxDecimalPoints: 0,
    largest: 2,
  })

  return format(milliseconds)
}
